import { JsonLd } from '../JsonLd';

export interface Breadcrumb {
  name: string;
  url: string;
}

interface Props {
  items: Breadcrumb[];
}

export function BreadcrumbListLd({ items }: Props) {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.name,
      item: item.url,
    })),
  };
  return <JsonLd schema={data} />;
}
